<template>
  <div>
    <header>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <!-- Hamburger Menu Button -->
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    
      <!-- Navbar Title (right justified) -->
      <div class="navbar-title ms-auto">
            <h5 class="navbar-brand mb-0">
              <span class="brand-lockup" aria-label="Polled Ya So!">
                <span class="brand-text-accent">P</span><span class="brand-text-mid">OLLED YA SO</span><span class="brand-text-bang">!</span>
              </span>
            </h5>
          </div>
    
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item active">
          <a class="nav-link" href="#" @click="currentView = 'home'">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" @click="currentView = 'leaderboard'">Leaderboard</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" @click="currentView = 'ourScores'">Our Team</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" @click="logout">Logout</a>
        </li>
      </ul>
    </div>
  </nav>
</header>

    <div class="container mt-5" v-if="currentView === 'home'">
      <div v-if="showRegistrationLogin">
        <p class="p-3 shadow-sm bg-light card-background mb-4 text-center fw-bold">We surveyed between 100-200 people in the CNY area. Can you guess the most popular answers? Free to play and prizes to win, just register a team below to get started!</p>
        <p></p>
        <p></p>
        <!-- Registration/Login Section -->
        <h5>Register a New Team</h5>
        <form @submit.prevent="createTeam">
          <div class="form-group">
            <label for="teamName">Team Name</label>
            <input type="text" v-model="teamName" class="form-control" id="teamName" required>
          </div>
         
          <div class="form-group">
            <label for="location">Select Location</label>
            <select v-model="selectedLocation" class="form-control" id="location" required>
              <option value="" disabled selected>Select a location</option>
              <option v-for="location in locations" :key="location.id" :value="location.id">
                {{ location.name }}
              </option>
            </select>
          </div>
        
          <button type="submit" class="btn btn-primary mt-3 custom-btn">Register Team</button>
        </form>

        <hr class="my-5">

        <h3>Log In with Team ID</h3>
        If you need to switch devices, login to your existing team with your team code. If you don't know your code, your host can give it to you!
        <p></p>
        <form @submit.prevent="loginWithTeamId">
          <div class="form-group">
            <label for="teamId">Team ID</label>
            <input type="text" v-model="loginTeamId" class="form-control" id="teamId" required autocomplete="off">
          </div>
          <button type="submit" class="btn btn-secondary mt-3 custom-btn-secondary">Log In</button>
        </form>
      </div>

      <div v-else>
        <!-- Game Status Section -->
        <h3>{{ teamName }}</h3>
        <p>Team ID: {{ teamId }}</p>

        <div v-if="!activeRound">
          <p class="p-3 shadow-sm bg-light card-background">Thanks for registering! The game will start soon. The answer sheet for the first round will appear here once the game starts.  In case your battery is running low, or you might need to switch who is answering questions later, take note of your Team ID above - you can use it to log back in to this team.</p>
        </div>

        <div v-else-if="activeRound && !hasSubmitted">
          <!-- Display Round Information and Answer Sheet -->
          <h3>Current Round: {{ activeRound.roundName }}</h3>
          <div class="instructions-container mb-3">
            <button 
              @click="showInstructions = !showInstructions" 
              class="btn btn-outline-primary instructions-toggle"
              type="button"
            >
              {{ showInstructions ? 'Hide Instructions' : 'Tap for instructions for this round' }}
            </button>
            <div v-if="showInstructions" class="instructions-content mt-2">
              <p class="p-3 shadow-sm bg-light card-background">{{ activeRound.roundDescription }}</p>
            </div>
          </div>
          <div v-if="activeRound.roundName == 'Social Media Bonus Points'">
          </div>
          <div v-else-if="activeRound.roundName != 'Social Media Bonus Points'">
            <form @submit.prevent="submitAnswers">
              <div v-for="(question, index) in displayQuestions" :key="index" class="form-group">
                <label :for="'question' + index">{{ question.label }}</label>
                
                <!-- Select input for "Wishbone Split" and "Popularity Contest" questions -->
                <select
                  v-if="(activeRound.roundName === 'Wishbone Split' && index === 0) || (activeRound.roundName === 'Popularity Contest' && question.type === 'wishbone')"
                  v-model="answers[index]"
                  :id="'question' + index"
                  class="form-control"
                  required
                >
                  <option value="" disabled selected>Select an option</option>
                  <option v-for="option in shuffledOptions[index]" :key="option" :value="option">
                    {{ option }}
                  </option>
                </select>

                <!-- Select input for "Win - Place - Show" wager question -->
                <select
                  v-else-if="activeRound.roundName === 'Win - Place - Show' && question.type === 'select'"
                  v-model="answers[index]"
                  :id="'question' + index"
                  class="form-control"
                  required
                >
                  <option value="" disabled selected>Select an option</option>
                  <option value="Win - Your answer must be #1">Win - Your answer must be #1</option>
                  <option value="Place - Your answer can be #1 or #2">Place - Your answer can be #1 or #2</option>
                  <option value="Show - Your answer can be in the top 3">Show - Your answer can be in the top 3</option>
                </select>

                                                                                                                    <!-- Perfect Placement drag-and-drop interface -->
                                       <div v-else-if="activeRound.roundName === 'Perfect Placement' && question.type === 'perfect-placement'" class="perfect-placement-container">
                    <div class="reorder-instructions mb-2">
                      <small class="text-muted">Click the number next to an answer to change its position. The top answer will be scored as #1, bottom as #{{ perfectPlacementAnswers[index].length }}.</small>
                    </div>
                    <div class="reorderable-answers">
                      <div
                        v-for="(answer, answerIndex) in (perfectPlacementAnswers[index] || [])"
                        :key="answerIndex"
                        class="reorderable-answer"
                      >
                        <div class="position-selector">
                          <select 
                            v-model="answerPositions[index][answerIndex]" 
                            @change="reorderAnswer(index, answerIndex, $event.target.value)"
                            class="position-dropdown"
                          >
                                                         <option 
                               v-for="position in perfectPlacementAnswers[index].length" 
                               :key="position" 
                               :value="position - 1"
                             >
                               {{ position }}
                             </option>
                          </select>
                        </div>
                        <input
                          v-model="perfectPlacementAnswers[index][answerIndex]"
                          :placeholder="`Answer ${answerIndex + 1}`"
                          class="form-control"
                          required
                          autocomplete="off"
                        />
                      </div>
                    </div>
                  </div>

                <!-- Text input for other questions -->
                <input
                  v-else
                  :type="question.type === 'numerical' ? 'number' : 'text'"
                  v-model="answers[index]"
                  :id="'question' + index"
                  class="form-control"
                  required
                  autocomplete="off"
                  step="0.01"
                >
              </div>
              <button type="submit" class="btn btn-primary mt-3 custom-btn">Submit Answers</button>
            </form>
          </div>
        </div>

        <div v-else>
          <p class="p-3 shadow-sm bg-light card-background mb-4 text-center fw-bold">Scoring in progress! The host will start the next round soon.</p>
        </div>
      </div>
    </div>

    <LeaderboardPage v-if="currentView === 'leaderboard'" :selectedLocation="selectedLocation" />
    <OurScoresPage v-if="currentView === 'ourScores'" />
  </div>
  <SelectOMaticPlayer
    v-if="currentGameId && teamId && !showRegistrationLogin"
    :game-id="currentGameId"
    :team-id="teamId"
    :team-name="teamName"
  />

  <footer></footer>
  <div v-if="isSubmitting" class="modal-overlay">
    <div class="loading-modal">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="loading-text">Submitting Answers...</div>
    </div>
  </div>
</template>
  
  <script>
  import { ref, onMounted, watch, onUnmounted, computed } from 'vue';
  import { db } from '@/firebase';
  import { collection, getDocs, getDoc, doc, query, where, setDoc, onSnapshot, runTransaction } from 'firebase/firestore';
  import LeaderboardPage from './LeaderboardPage.vue';
  import OurScoresPage from './OurScoresPage.vue';
  import SelectOMaticPlayer from './SelectOMaticPlayer.vue';
  
  export default {
    name: 'HomePage',
    components: {
      LeaderboardPage,
      OurScoresPage,
      SelectOMaticPlayer,
    },
    setup() {
      const teamName = ref('');
      const teamId = ref(localStorage.getItem('teamId') || '');
      const localStorageDate = ref(localStorage.getItem('date') || '');
      const selectedLocation = ref('');
      const locations = ref([]);
      const currentLocationName = ref('');
      const activeRound = ref(null);
      const hasSubmitted = ref(false);
      const answers = ref([]);
             const perfectPlacementAnswers = ref([]);
       const answerPositions = ref([]);
       const loginTeamId = ref('');
       const currentView = ref('home');
       const showRegistrationLogin = ref(false);
       const shuffledOptions = ref([]);
       const roundTypes = ref([]);
       const activeLocations = ref([]);
       const isSubmitting = ref(false);
       const showInstructions = ref(false);
      const showBuzzerView = ref(false);
      const buzzerIsActive = ref(false);
      const hasBuzzed = ref(false);
      const buzzOrder = ref(null);
      const currentGameId = ref('');
      let unsubscribeBuzzer = null;

      const fetchActiveLocations = async () => {
        try {
          const locationsSnapshot = await getDocs(collection(db, 'locations'));
          activeLocations.value = locationsSnapshot.docs
            .map(doc => ({ id: doc.id, ...doc.data() }))
            .filter(location => location.isActive);
        } catch (error) {
          console.error('Error fetching locations:', error);
        }
      };
      
      const generateShortId = () => {
        return Math.floor(10000 + Math.random() * 90000).toString();
      };
  
      const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      
      const updateShowRegistrationLogin = () => {
      showRegistrationLogin.value = !teamId.value || localStorageDate.value !== getTodayDate();
    };

      const createTeam = async () => {
        if (!teamName.value.trim()) {
          alert('Please enter a team name.');
          return;
        }
        if (!selectedLocation.value) {
          alert('Please select a location.');
          return;
        }

        let uniqueId;
        let idExists = true;
  
        while (idExists) {
          uniqueId = generateShortId().toString();
          const existingTeamQuery = query(collection(db, 'teams'), where('teamId', '==', uniqueId));
          const querySnapshot = await getDocs(existingTeamQuery);
          idExists = !querySnapshot.empty;
        }
  
        const gameQuery = query(
          collection(db, 'games'),
          where('location', '==', selectedLocation.value),
          where('date', '==', getTodayDate())
        );
        const gameSnapshot = await getDocs(gameQuery);
        if (!gameSnapshot.empty) {
          const gameId = gameSnapshot.docs[0].id;
  
          await setDoc(doc(db, 'teams', uniqueId), {
            teamId: uniqueId,
            teamName: teamName.value,
            location: selectedLocation.value,
            gameId: gameId,
          });
  
          teamId.value = uniqueId;
          localStorage.setItem('teamId', teamId.value);
          localStorage.setItem('location', selectedLocation.value);
          localStorage.setItem('date', getTodayDate());
          showRegistrationLogin.value = false;
          currentView.value = 'home'
          window.location.reload();
        } else {
          alert('No active game found for this location and date.');
        }
      };
  
      const loginWithTeamId = async () => {
        const docRef = doc(db, 'teams', loginTeamId.value);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          teamName.value = docSnap.data().teamName;
          selectedLocation.value = docSnap.data().location;
          currentLocationName.value = locations.value.find(location => location.id === selectedLocation.value)?.name || '';
          teamId.value = loginTeamId.value;
          localStorage.setItem('teamId', teamId.value);
          localStorage.setItem('location', selectedLocation.value);
          localStorage.setItem('date', getTodayDate());
          window.location.reload();
  
          loadActiveRound();
        } else {
          alert('Team ID not found. Please check and try again.');
        }
      };
  
      const loadActiveRound = () => {
        if (!teamId.value) {
          return;
        }

        const teamRef = doc(db, 'teams', teamId.value);
        
        return onSnapshot(teamRef, async (teamSnap) => {
          if (teamSnap.exists()) {
            const gameId = teamSnap.data().gameId;
            currentGameId.value = gameId;

            // Subscribe to buzzer state for this team
            const buzzerRef = doc(db, `games/${gameId}/buzzers/${teamId.value}`);
            if (unsubscribeBuzzer) {
              unsubscribeBuzzer();
            }
            unsubscribeBuzzer = onSnapshot(buzzerRef, (buzzerSnap) => {
              if (buzzerSnap.exists()) {
                const data = buzzerSnap.data();
                showBuzzerView.value = !!data.enabled;
                hasBuzzed.value = !!data.order;
                buzzOrder.value = data.order || null;
              } else {
                showBuzzerView.value = false;
                hasBuzzed.value = false;
                buzzOrder.value = null;
              }
            });

            const roundsQuery = query(
              collection(db, `games/${gameId}/rounds`),
              where('isActive', '==', true)
            );

            const roundsUnsubscribe = onSnapshot(roundsQuery, (roundsSnapshot) => {
              if (!roundsSnapshot.empty) {
                const activeRoundDoc = roundsSnapshot.docs[0];
                const roundData = activeRoundDoc.data();

                const roundTypeRef = doc(db, `roundTypes/${roundData.roundType}`);
                getDoc(roundTypeRef).then(roundTypeSnap => {
                  if (roundTypeSnap.exists()) {
                    const roundTypeData = roundTypeSnap.data();
                    const answerTypes = roundTypeData.answerTypes || [];

                    activeRound.value = {
                      ...roundData,
                      id: activeRoundDoc.id,
                      questions: roundData.questions.map((q, index) => ({
                        ...q,
                        label: answerTypes[index]?.label || `Question ${index + 1}`,
                      })),
                    };

                    if (activeRound.value.questions.length > 0) {
                      answers.value = Array(activeRound.value.questions.length).fill('');
                    }

                    // Update shuffledOptions
                    shuffledOptions.value = activeRound.value.questions.map(question => {
                      if (question.type === 'wishbone') {
                        return shuffleArray([...question.options]);
                      }
                      return question.options || [];
                    });

                    const submissionQuery = query(
                      collection(db, `games/${gameId}/submissions`),
                      where('roundId', '==', activeRound.value.id),
                      where('teamId', '==', teamId.value)
                    );

                    getDocs(submissionQuery).then(submissionSnapshot => {
                      hasSubmitted.value = !submissionSnapshot.empty;
                    });
                  }
                });
              } else {
                activeRound.value = null;
              }
            });

            return () => {
              roundsUnsubscribe();
            };
          }
        });
      };

  
    const displayQuestions = computed(() => {
      if (!activeRound.value || !activeRound.value.roundType) return [];

      const roundType = roundTypes.value.find(rt => rt.id === activeRound.value.roundType);
      if (!roundType) return [];

      if (activeRound.value.roundName === 'Wishbone Split') {
        return activeRound.value.questions.map((q, index) => ({
          ...q,
          label: q.label || `Question ${index + 1}`,
          type: index === 0 ? 'wishbone' : 'numerical' // Ensure type is set to 'wishbone' for the first question and 'numerical' for the second
        }));
      } else if (activeRound.value.roundName === 'Win - Place - Show') {
        return [
          {
            label: 'Your Answer',
            type: 'text'
          },
          {
            label: 'Your Wager',
            type: 'select'
          }
        ];
      } else if (activeRound.value.roundName === 'Popularity Contest') {
        return activeRound.value.questions.map((q, index) => ({
          ...q,
          label: q.label || `Question ${index + 1}`,
          type: 'wishbone' // Ensure type is set to 'wishbone' for all questions in Popularity Contest
        }));
             } else if (activeRound.value.roundName === 'Perfect Placement') {
         // For Perfect Placement, we only want ONE question with 5 draggable answers
         const roundType = roundTypes.value.find(rt => rt.id === activeRound.value.roundType);
         const numCorrectAnswers = roundType?.numCorrectAnswers || 5;
         return [{
           label: 'Top 5 Most Popular Answers (in order!)',
           type: 'perfect-placement',
           numCorrectAnswers: numCorrectAnswers
         }];
       } else {
        const numQuestions = roundType.numQuestions || 1; // Default to 1 if not specified
        return Array(numQuestions).fill().map((_, index) => ({
          type: 'text', // Default to text input
          label: `Question ${index + 1}`,
          // If there's a corresponding question in activeRound.value.questions, use its properties
          ...(activeRound.value.questions[index] || {})
        }));
      }
    });

    // Watch for changes in displayQuestions and update answers array accordingly
    watch(displayQuestions, (newQuestions) => {
      answers.value = newQuestions.map(question => 
        question.type === 'numerical' ? 0 : 
        question.type === 'wishbone' ? '' : ''
      );
      
                                                              // Initialize perfectPlacementAnswers for Perfect Placement questions
          if (activeRound.value?.roundName === 'Perfect Placement') {
            const roundType = roundTypes.value.find(rt => rt.id === activeRound.value.roundType);
            const numAnswers = roundType?.numCorrectAnswers || 5;
            // For Perfect Placement, we only need ONE array with 5 answers
            perfectPlacementAnswers.value = [Array(numAnswers).fill('')];
            // Initialize answerPositions with sequential positions
            answerPositions.value = [Array.from({ length: numAnswers }, (_, i) => i)];
          } else {
            perfectPlacementAnswers.value = [];
            answerPositions.value = [];
          }
    }, { immediate: true });

    const submitAnswers = async () => {
      const isValidAnswer = (answer) => {
        if (typeof answer === 'string') {
          return answer.trim() !== '';
        } else if (typeof answer === 'number') {
          return !isNaN(answer);
        }
        return false;
      };

                                       // For Perfect Placement questions, validate the answers
          const isValidPerfectPlacement = () => {
            if (activeRound.value?.roundName === 'Perfect Placement') {
              // Check if the first (and only) question has answers and they're all filled
              const questionAnswers = perfectPlacementAnswers.value[0];
              return questionAnswers && 
                     questionAnswers.length > 0 && 
                     questionAnswers.every(answer => answer && answer.trim() !== '');
            }
            return true;
          };

             // Check if all answers are valid
       let allAnswersValid;
       if (activeRound.value?.roundName === 'Perfect Placement') {
         // For Perfect Placement, only validate the perfectPlacementAnswers
         allAnswersValid = isValidPerfectPlacement();
       } else {
         // For other rounds, validate the regular answers
         allAnswersValid = answers.value.every(isValidAnswer);
       }

      if (allAnswersValid) {
        isSubmitting.value = true;
        try {
          const teamDocRef = doc(db, 'teams', teamId.value);
          const teamDoc = await getDoc(teamDocRef);
          
          if (!teamDoc.exists()) {
            throw new Error('Team not found');
          }

          const gameId = teamDoc.data().gameId;
          
          if (!gameId) {
            throw new Error('Game ID not found for team');
          }

                                            // Prepare answers array, handling Perfect Placement questions
             let finalAnswers;
             if (activeRound.value?.roundName === 'Perfect Placement') {
               // For Perfect Placement, return the single ordered array of answers
               finalAnswers = perfectPlacementAnswers.value[0] || [];
             } else {
               finalAnswers = answers.value;
             }

          const submissionData = {
            roundId: activeRound.value.id,
            roundName: activeRound.value.roundName,
            answers: finalAnswers,
            teamId: teamId.value,
            submittedAt: new Date(),
          };

          const submissionRef = doc(db, `games/${gameId}/submissions/${teamId.value}_${activeRound.value.id}`);
          await setDoc(submissionRef, submissionData);
          hasSubmitted.value = true;
        } catch (error) {
          console.error('Error submitting answers:', error);
          alert('There was an error submitting your answers. Please try again.');
        } finally {
          isSubmitting.value = false;
        }
      } else {
        alert('Please answer all questions with valid inputs.');
      }
    };

    const shuffleArray = (array) => {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    };

                   // Reordering methods for Perfect Placement round type
          const reorderAnswer = (questionIndex, answerIndex, newPosition) => {
            const newPositionInt = parseInt(newPosition);
            if (newPositionInt === answerIndex) return; // No change needed
            
            const answers = [...perfectPlacementAnswers.value[questionIndex]];
            const [movedAnswer] = answers.splice(answerIndex, 1);
            answers.splice(newPositionInt, 0, movedAnswer);
            perfectPlacementAnswers.value[questionIndex] = answers;
            
            // Update the position selectors to reflect the new order
            updatePositionSelectors(questionIndex);
          };
          
          const updatePositionSelectors = (questionIndex) => {
            // After reordering, reset the position selectors to show the new order
            const numAnswers = perfectPlacementAnswers.value[questionIndex].length;
            answerPositions.value[questionIndex] = Array.from({ length: numAnswers }, (_, i) => i);
          };
          


    const fetchRoundTypes = async () => {
      try {
        const roundTypesSnapshot = await getDocs(collection(db, 'roundTypes'));
        roundTypes.value = roundTypesSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      } catch (error) {
        console.error('Error fetching round types:', error);
      }
    };

         watch(() => activeRound.value, (newRound) => {
       if (newRound) {
         shuffledOptions.value = newRound.questions.map(question => {
           if (question.type === 'wishbone') {
             return shuffleArray([...question.options]);
           }
           return question.options || [];
         });
         
                                       // Initialize perfectPlacementAnswers when round changes
           if (newRound.roundName === 'Perfect Placement') {
             const roundType = roundTypes.value.find(rt => rt.id === newRound.roundType);
             const numCorrectAnswers = roundType?.numCorrectAnswers || 5;
             // For Perfect Placement, we only need ONE array with 5 answers
             perfectPlacementAnswers.value = [Array(numCorrectAnswers).fill('')];
             // Initialize answerPositions with sequential positions
             answerPositions.value = [Array.from({ length: numCorrectAnswers }, (_, i) => i)];
           } else {
             perfectPlacementAnswers.value = [];
             answerPositions.value = [];
           }
       }
     }, { immediate: true });

    let unsubscribeActiveRound = null;

         onMounted(async () => {
       await fetchRoundTypes();

       const locationsQuery = query(
         collection(db, 'locations'),
         where('isActive', '==', true)
       );

       const locationsSnapshot = await getDocs(locationsQuery);

       locations.value = locationsSnapshot.docs.map(doc => ({
         id: doc.id,
         name: doc.data().name,
       }));

       // Auto-select location if only one is available and user is not logged in
       if (!teamId.value && locations.value.length === 1) {
         selectedLocation.value = locations.value[0].id;
       }

       if (teamId.value) {
         const teamRef = doc(db, 'teams', teamId.value);
         const teamSnap = await getDoc(teamRef);

         if (teamSnap.exists()) {
           teamName.value = teamSnap.data().teamName;
           selectedLocation.value = teamSnap.data().location;
           currentLocationName.value = locations.value.find(location => location.id === selectedLocation.value)?.name || '';
         }
         unsubscribeActiveRound = loadActiveRound();
       }

       await fetchActiveLocations();
       
                               // Ensure perfectPlacementAnswers is initialized
         perfectPlacementAnswers.value = [];
         answerPositions.value = [];
     });

         onUnmounted(() => {
       if (unsubscribeActiveRound) {
         unsubscribeActiveRound();
       }
     });

    watch([teamId, localStorageDate], updateShowRegistrationLogin);

    updateShowRegistrationLogin();

    const logout = () => {
      if (confirm(`Are you sure you want to log out?\nYour Team ID is: ${teamId.value}\nPlease save this ID - you will need it to log back in.`)) {
        localStorage.removeItem('teamId');
        localStorage.removeItem('location');
        localStorage.removeItem('date');
        window.location.reload();
      }
    };

    const pressBuzzer = async () => {
      if (!showBuzzerView.value || hasBuzzed.value || !currentGameId.value) return;

      try {
        const gameRef = doc(db, 'games', currentGameId.value);
        const buzzerRef = doc(db, `games/${currentGameId.value}/buzzers/${teamId.value}`);

        await runTransaction(db, async (transaction) => {
          const gameSnap = await transaction.get(gameRef);
          const buzzerSnap = await transaction.get(buzzerRef);

          const gameData = gameSnap.exists() ? gameSnap.data() : {};
          const isActive = !!gameData.buzzersActive;

          if (!isActive) {
            return;
          }

          const buzzerData = buzzerSnap.exists() ? buzzerSnap.data() : {};
          if (buzzerData.order) {
            return;
          }

          const currentCounter = gameData.buzzerCounter || 0;
          const newCounter = currentCounter + 1;

          transaction.update(gameRef, { buzzerCounter: newCounter });
          transaction.set(
            buzzerRef,
            {
              buzzedAt: new Date(),
              order: newCounter,
            },
            { merge: true }
          );
        });
      } catch (error) {
        console.error('Error pressing buzzer:', error);
      }
    };

         return {
       teamName,
       teamId,
       selectedLocation,
       locations,
       currentLocationName,
       activeRound,
       hasSubmitted,
       answers,
       loginTeamId,
       currentView,
       showRegistrationLogin,
       shuffledOptions,
       createTeam,
       loginWithTeamId,
       submitAnswers,
       displayQuestions,
       roundTypes,
       activeLocations,
       isSubmitting,
       showInstructions,
                                                           perfectPlacementAnswers,
          answerPositions,
          reorderAnswer,
          logout,
         showBuzzerView,
         buzzerIsActive,
         hasBuzzed,
         buzzOrder,
         pressBuzzer,
         currentGameId,
     };
  },
};
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Lilita+One&display=swap');




select {
  /* Make sure the dropdown covers the full width of its container */
  width: 100%;
  
  /* Add padding for better touch interaction */
  padding: 0.75rem;
  
  /* Increase font size for readability */
  font-size: 1rem;
  
  /* Use a border that matches your design style */
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  
  /* Add a subtle shadow for depth */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  /* Optional: Customize the appearance on focus */
  outline: none;
  border-color: #a78bfa;
}

select:focus {
  /* Change border color on focus to make it more noticeable */
  border-color: #7c3aed;
}
/* Card Background */
.card-background {
  background: linear-gradient(145deg, #ddd6fe, #ede9fe);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 25px !important; /* Higher value for more rounded corners */
  padding: 1rem;
  /* border: 2px solid #d35400; /* Dark Orange Border */
  width: 100%; /* Ensure it takes the full width of its container */
  max-width: 400px; /* Optional: Set a max-width to control its size */
  margin: auto; /* Center the card horizontally */
}


/* Button Styles */
.custom-btn {
  background: linear-gradient(45deg, #6d28d9, #a855f7);
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 8px;
  transition: background 0.3s ease, box-shadow 0.3s ease;
}
.custom-btn:hover {
  background: linear-gradient(45deg, #a855f7, #6d28d9);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.custom-btn-secondary {
  background-color: #c4b5fd;
  border: none;
  color: #4c1d95;
}

.custom-btn-secondary:hover {
  background-color: #a78bfa;
  color: #3b0764;
}

.form-control {
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 0.5rem;
  font-size: 1rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-control:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 8px rgba(139, 92, 246, 0.45);
  outline: none;
}

/* Padding and Shadow */
.p-3 {
  margin-bottom: 1rem;
  padding: 1.5rem !important;
  border-radius: 0.25rem;
  background-color: #faf5ff !important;
}

.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, 0.075) !important;
}

.navbar-title {
  flex-grow: 1;
  text-align: right;
}

.navbar-brand {
  margin-bottom: 0;
  line-height: 1;
}

/* Logo lockup: yellow type, white outline, dark purple capsule (matches brand art) */
.brand-lockup {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: baseline;
  white-space: nowrap;
  font-family: 'Lilita One', sans-serif;
  font-size: clamp(1.09rem, 3.68vw, 1.78rem);
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #ffeb3b;
  background: #2e1065;
  border: 2px solid #fff;
  border-radius: 9999px;
  padding: 0.15em 0.7em 0.22em;
  box-shadow:
    0 0 0 2px #ffeb3b,
    0 4px 14px rgba(45, 16, 101, 0.45);
  -webkit-text-stroke: 1px #fff;
  paint-order: stroke fill;
}

.brand-text-accent {
  font-size: 1.3em;
  line-height: 1;
}

.brand-text-mid {
  font-size: 1em;
}

.brand-text-bang {
  font-size: 1.2em;
  line-height: 1;
  display: inline-block;
  transform: rotate(11deg) translateY(-0.06em);
  margin-left: 0.03em;
}

.navbar-light {
  color: #ede9fe;
}

.navbar {
  background: linear-gradient(90deg, #5b21b6, #7c3aed, #c084fc) !important;
  display: flex;
  justify-content: left; /* Centers the content horizontally */
  padding: 1rem;
}

.navbar .nav-link {
  color: rgba(255, 255, 255, 0.92) !important;
}

.navbar .nav-link:hover {
  color: #fff !important;
}

.navbar .navbar-toggler {
  border: 1px solid rgba(255, 255, 255, 0.95) !important;
}

.navbar .navbar-toggler:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.35);
}

.navbar .navbar-toggler-icon {
  filter: brightness(0) invert(1);
}

/* Footer */
footer {
  height: 50px;
}

/* Add these styles for the select dropdown */
select.form-control {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23333' viewBox='0 0 12 12'%3E%3Cpath d='M10.293 3.293a1 1 0 011.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L6 7.586l4.293-4.293z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 12px;
  padding-right: 2rem;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.loading-modal {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.loading-text {
  margin-top: 1rem;
  font-size: 1.1rem;
  color: #666;
}

 /* Perfect Placement Reordering Styles */
 .perfect-placement-container {
   margin-bottom: 1rem;
 }

 .reorder-instructions {
   font-size: 0.875rem;
   color: #6c757d;
 }

 .reorderable-answers {
   display: flex;
   flex-direction: column;
   gap: 0.5rem;
 }

 .reorderable-answer {
   display: flex;
   align-items: center;
   gap: 0.75rem;
   padding: 0.75rem;
   background-color: #f8f9fa;
   border: 2px solid #e9ecef;
   border-radius: 8px;
   transition: all 0.2s ease;
   position: relative;
 }

 .reorderable-answer:hover {
   background-color: #e9ecef;
   border-color: #8b5cf6;
   transform: translateY(-1px);
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
 }

 .position-selector {
   display: flex;
   align-items: center;
   justify-content: center;
   min-width: 60px;
 }

 .position-dropdown {
   width: 100%;
   padding: 0.5rem;
   border: 2px solid #8b5cf6;
   border-radius: 6px;
   background-color: white;
   color: #333;
   font-size: 0.875rem;
   font-weight: bold;
   text-align: center;
   cursor: pointer;
   transition: all 0.2s ease;
 }

 .position-dropdown:focus {
   outline: none;
   border-color: #6d28d9;
   box-shadow: 0 0 8px rgba(139, 92, 246, 0.35);
 }

 .position-dropdown:hover {
   border-color: #6d28d9;
   background-color: #f5f3ff;
 }

 .reorderable-answer input {
   flex: 1;
   margin: 0;
   border: 2px solid #ddd;
   background-color: white;
   font-size: 1rem;
   padding: 0.5rem;
   border-radius: 6px;
   transition: all 0.2s ease;
 }

 .reorderable-answer input:focus {
   outline: none;
   border-color: #8b5cf6;
   box-shadow: 0 0 8px rgba(139, 92, 246, 0.35);
   background-color: #faf5ff;
 }

 /* Mobile responsiveness for reordering */
 @media (max-width: 768px) {
   .reorderable-answer {
     padding: 0.5rem;
     gap: 0.5rem;
   }
   
   .position-dropdown {
     padding: 0.4rem;
     font-size: 0.8rem;
     min-width: 50px;
   }
   
       .reorderable-answer input {
      font-size: 0.9rem;
      padding: 0.4rem;
    }
 }

 /* Instructions Button Styles */
 .instructions-container {
   text-align: center;
 }

 .instructions-toggle {
   background: linear-gradient(45deg, #6d28d9, #a855f7);
   border: none;
   color: white;
   padding: 0.75rem 1.5rem;
   font-size: 1rem;
   border-radius: 8px;
   transition: all 0.3s ease;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
 }

 .instructions-toggle:hover {
   background: linear-gradient(45deg, #a855f7, #6d28d9);
   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
   transform: translateY(-1px);
 }

 .instructions-toggle:focus {
   outline: none;
   box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.35);
 }

 .instructions-content {
   animation: fadeIn 0.3s ease-in;
 }

 @keyframes fadeIn {
   from {
     opacity: 0;
     transform: translateY(-10px);
   }
   to {
     opacity: 1;
     transform: translateY(0);
   }
 }
</style>
  